/**
 * Normalize WordPress REST paths for Gatsby routes (shared by gatsby-node and the browser bundle).
 * Adds a trailing slash for non-root paths so Link targets match createPage paths (avoids missing page-data JSON in dev).
 *
 * @param {string|undefined|null} uri Path or full URL from WordPress.
 * @returns {string}
 */
function resolveWordPressPathForGatsby(uri) {
  if (!uri || typeof uri !== 'string') {
    return '/'
  }

  const trimmed = uri.trim()
  if (!trimmed) {
    return '/'
  }

  let combined

  if (trimmed.startsWith('/')) {
    combined = trimmed
  } else if (/^https?:\/\//i.test(trimmed)) {
    try {
      const u = new URL(trimmed)
      combined = `${u.pathname || '/'}${u.search}${u.hash}`
    } catch {
      return '/'
    }
  } else {
    combined = `/${trimmed.replace(/^\/+/, '')}`
  }

  if (combined.length <= 1) {
    return '/'
  }

  const pathOnly = combined.split('?')[0].split('#')[0]

  if (pathOnly === '/' || pathOnly === '') {
    return '/'
  }

  const looksLikeFile = /\.[a-z0-9]{2,5}$/i.test(pathOnly)

  if (looksLikeFile) {
    return combined
  }

  if (pathOnly.endsWith('/')) {
    return combined
  }

  const rest = combined.slice(pathOnly.length)

  return `${pathOnly}/${rest}`
}

module.exports = { resolveWordPressPathForGatsby }
